import { Injectable } from '@angular/core';
import type { UrlSerializer, UrlTree, Params } from '@angular/router';
import { DefaultUrlSerializer } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class JsonUrlSerializer implements UrlSerializer {
  private readonly inner = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    const tree = this.inner.parse(url);
    for (const k of Object.keys(tree.queryParams)) {
      const v = tree.queryParams[k];
      if (typeof v === 'string' && v.startsWith('__json__:')) {
        try {
          tree.queryParams[k] = JSON.parse(v.slice('__json__:'.length));
        } catch {
          /* hagyjuk stringnek */
        }
      }
    }
    return tree;
  }

  serialize(tree: UrlTree): string {
    // Elmentjük az eredeti query paramétereket
    const originalParams = tree.queryParams;

    const normalized: Params = { ...originalParams };
    for (const k of Object.keys(normalized)) {
      const v = normalized[k];
      const isComplex = v !== null && typeof v === 'object';
      if (isComplex) normalized[k] = '__json__:' + JSON.stringify(v);
    }

    // Átmenetileg felülírjuk a fán a paramétereket
    tree.queryParams = normalized;
    const result = this.inner.serialize(tree);

    // Visszaállítjuk az eredetit, hogy ne okozzunk mellékhatást máshol
    tree.queryParams = originalParams;

    return result;
  }
}
